import { tenantHttp, type HttpClient, type QueryParams } from './core/http-client';
import type { BusinessReview, BusinessReviewDetail, Tag } from './models';

export class ReviewsService {
  constructor(private readonly http: HttpClient) {}

  list = (query: QueryParams, signal?: AbortSignal) =>
    this.http.getPage<BusinessReview>('/business/reviews', { query, signal });

  get = (id: string) => this.http.get<BusinessReviewDetail>(`/business/reviews/${id}`);

  reply = (id: string, content: string) =>
    this.http.put(`/business/reviews/${id}/reply`, { content });

  deleteReply = (id: string) => this.http.delete(`/business/reviews/${id}/reply`);

  setTags = (id: string, tagIds: string[]) =>
    this.http.put<Tag[]>(`/business/reviews/${id}/tags`, { tagIds });

  report = (id: string, reason: string, details?: string) =>
    this.http.post(`/business/reviews/${id}/reports`, { reason, details });

  tags = () => this.http.get<Tag[]>('/business/tags');

  createTag = (group: string, value: string) =>
    this.http.post<Tag>('/business/tags', { group, value });
}

export const reviewsService = new ReviewsService(tenantHttp);
